module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hant_tohoku-e983fa8b81589ba4860ac2bbce1dac31.jpg";